import Player from '@vimeo/player';

var VideoHero = function($el, opts)
{
    this.$el = $el;
    this.opts = $.extend(true, {}, VideoHero.defaults, opts);
    this.animationId = null;
    this.maxOffsetY = 0;
    this.offsetY = { current: 0, target: 0 };
    this.$bg = this.$el.find('.bg').eq(0);
    this.ready = false;

    var iframe = this.$el.find('iframe').eq(0).get(0);
    if (!!iframe) {

        this.player = new Player(iframe, {
            background: true,
            loop: true,
            autoplay: 1,
            autopause: false
        });

        // Consider the video 'ready' when > 1 second is loaded
        this.player.on('progress', function(e) {
            if (e.seconds > 1) {
                this.onVideoReady();
                this.player.off('progress');
            }
        }.bind(this));
    }

    // Add class for fade in effect
    setTimeout(function() {
        this.$el.addClass('initialised');
    }.bind(this), 1);

    this.videoEnabled = true;
    this.init();
}

VideoHero.prototype.init = function()
{
    $(window).on('resize load',function() {
        clearTimeout(this.debounceTimeout);
        this.debounceTimeout = setTimeout(this.update.bind(this), 50);
    }.bind(this));

    this.update();
    this.startAnimation()
}

VideoHero.prototype.update = function()
{
    var display = this.$el.find('iframe').css('display');

    if (!!display && display === 'none') {
        this.disableVideo();
    } else {
        this.enableVideo();
    }

    this.maxOffsetY = this.$el.offset().top + this.$el.height();
}

VideoHero.prototype.onVideoReady = function()
{
    if (!this.ready) {
        this.$el.addClass('video-ready');
        this.ready = true;
    }
}

VideoHero.prototype.enableVideo = function()
{
    if (this.videoEnabled) {
        return;
    }
    if (!!this.player) {
        this.player.play();
    }
    this.videoEnabled = true;
}

VideoHero.prototype.disableVideo = function()
{
    if (!this.videoEnabled) {
        return;
    }
    if (!!this.player) {
        this.player.pause();
    }
    this.videoEnabled = false;
}

VideoHero.prototype.startAnimation = function()
{
    if (!!this.animationId) {
        return;
    }
    this.animationId = requestAnimationFrame(this.frameHandler.bind(this));

    $(window).on('scroll.videohero resize.videohero', function() {
        this.offsetY.target = Math.min(this.maxOffsetY, $(window).scrollTop()) * this.opts.parallaxRatio;
    }.bind(this));
}

VideoHero.prototype.stopAnimation = function()
{
    if (!this.animationId) {
        return;
    }
    cancelAnimationFrame(this.animationId);
    this.animationId = null;
    $(window).off('scroll.videohero resize.videohero');
}

VideoHero.prototype.frameHandler = function()
{
    if (Math.abs(this.offsetY.target - this.offsetY.current) > 0.01) {
        this.offsetY.current += ((this.offsetY.target - this.offsetY.current) / 2);
        this.$bg.css('transform', 'translateY(' + this.offsetY.current + 'px)');
    } else if (this.offsetY.target !== this.offsetY.current) {
        this.offsetY.current = this.offsetY.target;
    }
    this.animationId = requestAnimationFrame(this.frameHandler.bind(this));
}

VideoHero.defaults = {
    minimumPlaybackWidth: 768,
    parallaxRatio: 0.65
}

VideoHero.init = function($scope)
{
    $($scope || '.hero-video').each(function (i, el) {
        if (!$(el).data('VideoHero')) {
            $(el).data('VideoHero', new VideoHero($(el), $(el).data()));
        }
    }.bind(this));

    if (!this.initialised) {

        this.initialised = true;

    }
}

export default VideoHero;